var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.9166,
    height: 51.0015,
    viewBox: "0 0 41.9166 51.0015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d0cfce;}.cls-2{fill:#61b2e4;}.cls-3{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.9583,14.0849c8.7995,0,15.9583,7.1589,15.9583,15.9583s-7.1588,15.9583-15.9583,15.9583-15.9583-7.1589-15.9583-15.9583,7.1588-15.9583,15.9583-15.9583m0-4C9.9356,10.0849,1,19.0206,1,30.0432s8.9356,19.9583,19.9583,19.9583,19.9583-8.9356,19.9583-19.9583S31.981,10.0849,20.9583,10.0849h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.647 6.0432 16.9796 6.0432 15.9796 1 25.647 1 24.647 6.0432"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 20.9583,
    cy: 30.0432,
    r: 19.9583
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.2662,
    y1: 1.0015,
    x2: 14.5165,
    y2: 7.4711
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30.2084,
    y1: 1,
    x2: 26.9582,
    y2: 7.4696
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.647 6.0432 16.9796 6.0432 15.9796 1 25.647 1 24.647 6.0432"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.195c5e258cff94f183ea68d0b2392913.svg";
export { ForwardRef as ReactComponent };